import serializable from "../common/decorators/serializable";
import { EntityFirebase } from "../common/entity.firebase";

/** Categoria configurável de retirada de caixa.
 *  A categoria especial "pay_bill" (pagar conta) é fixa no código — não fica aqui. */
@serializable
export class CashWithdrawalCategory extends EntityFirebase {
  constructor(
    public readonly id: string,
    private title: string
  ) {
    super();
  }

  getTitle() { return this.title; }
  setTitle(v: string) { this.title = v; }

  static async build(id: string, data: Record<string, unknown>) {
    return new this(
      id,
      typeof data.title === "string" ? data.title : ""
    );
  }
}
